"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestExtractPinoutDefinition = void 0;
const z = require("zod");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const package_common_1 = require("../../../Datatypes/package-common");
exports.TestExtractPinoutDefinition = {
    type: 'TestExtractPinout',
    displayName: 'Test Extract Pinout',
    inputSchema: z.object({
        packageName: z.string(),
        packageFamilyName: z.string(),
        datasheetUri: package_common_1.DatasheetUriSchema,
        signals: z.array(sigma_engine_shared_1.SignalSchema),
    }),
    outputSchema: z.object({
        pinout: package_common_1.PinoutSchema,
    }),
};
//# sourceMappingURL=test-extract-pinout.js.map